module.exports = __webpack_public_path__ + "img/canyon_natural_ba_list.f56b2464.jpg";